<template>
  <div class="disable-scroll-x">
    <div
      style="
        background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
      "
    >
      <CRow class="ml-5 mr-5 mb-5">
        <Mainlayout></Mainlayout>
        <br /><br /><br />
      </CRow>

      <CContainer>
        <div class="text-center d-sm-down-none">
          <h3 class="custom-64px text-white text-center">
            Category Help Center
          </h3>
          <div class="mt-5">
            <CButton
              color="info"
              class="custom-btn-login-forgot"
              @click="ShowParent()"
              :style="
                isShowParent
                  ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;height:auto'
                  : 'background:#ffffff;border: 1px solid white;color:#000;font-family: Montserrat;font-style: normal;font-weight: 600;height:auto'
              "
            >
              <img src="../assets/img/icon/g1.svg" />
              <br />
              Registration</CButton
            >
            <!-- <CButton color="info" class="custom-btn-login-forgot ml-2" @click="ShowOnlineTutor()" :style="isShowOnline ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;' : 'background:none;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'">
              Online Tutor</CButton
            > -->

            <CButton
              color="info"
              class="custom-btn-login-forgot ml-2"
              @click="ShowTc()"
              :style="
                isShowTc
                  ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;height:auto'
                  : 'background:#ffffff;border: 1px solid white;color:#000;font-family: Montserrat;font-style: normal;font-weight: 600;height:auto'
              "
            >
              <img src="../assets/img/icon/G2.svg" />
              <br />
              Package</CButton
            >

            <CButton
              color="info"
              class="custom-btn-login-forgot ml-2"
              @click="ShowClass()"
              :style="
                isShowClass
                  ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;height:auto'
                  : 'background:#ffffff;border: 1px solid white;color:#000;font-family: Montserrat;font-style: normal;font-weight: 600;height:auto'
              "
            >
              <img src="../assets/img/icon/G3.svg" />
              <br />
              Tutor</CButton
            >

            <CButton
              color="info"
              class="custom-btn-login-forgot ml-2"
              @click="ShowClass()"
              :style="
                isShowClass
                  ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;height:auto'
                  : 'background:#ffffff;border: 1px solid white;color:#000;font-family: Montserrat;font-style: normal;font-weight: 600;height:auto'
              "
            >
              <img src="../assets/img/icon/G4.svg" />
              <br />
              List Subject</CButton
            >
          </div>
        </div>

        <div class="text-center d-md-none">
          <h3 class="custom-32px text-white text-center">
            Category Help Center
          </h3>
          <div class="mt-5">
            <CButton
              color="info"
              class="custom-btn-login-forgot"
              @click="ShowParent()"
              :style="
                isShowParent
                  ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                  : 'background:none;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'
              "
            >
              Registration</CButton
            >
            <!-- <br /><br />
            <CButton color="info" class="custom-btn-login-forgot" @click="ShowOnlineTutor()" :style="isShowOnline ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;' : 'background:none;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'">
              Online Tutor</CButton
            > -->
            <br /><br />
            <CButton
              color="info"
              class="custom-btn-login-forgot"
              @click="ShowTc()"
              :style="
                isShowTc
                  ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                  : 'background:none;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'
              "
            >
              Package</CButton
            >
            <br /><br />
            <CButton
              color="info"
              class="custom-btn-login-forgot"
              @click="ShowClass()"
              :style="
                isShowClass
                  ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                  : 'background:none;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'
              "
            >
              Tutor</CButton
            >
            <br /><br />
            <CButton
              color="info"
              class="custom-btn-login-forgot"
              @click="ShowClass()"
              :style="
                isShowClass
                  ? 'color: #007cef;background: #ffffff;font-family: Montserrat;font-style: normal;font-weight: 600;'
                  : 'background:none;border: 1px solid white;color:#fff;font-family: Montserrat;font-style: normal;font-weight: 600;'
              "
            >
              List Subject</CButton
            >
          </div>
        </div>
      </CContainer>

      <CRow v-if="ParentPrice === true">
        <div class="card-custom-web">
          <div class="text-center mt-5">
            <CRow style="max-width: 100%">
              <CCol sm="4"
                ><h2>
                  <img
                    style="max-height: 40px"
                    class="mr-2"
                    src="../assets/img/icon/circle1.png"
                  /><strong>Register Pickiddo</strong>
                </h2></CCol
              >
              <CCol sm="8">
                <CCard color="light">
                  <div class="p-2">
                    <h4 class="text-left">
                      <strong>How to Register ?</strong>
                    </h4>
                  </div>
                </CCard>

                <CCard>
                  <div class="p-2">
                    <h4 class="text-left">
                      <strong>1. Download our Pickiddo app:</strong>
                      <br />
                      <br />
                      Android user: : <br />
                      <a
                        href="https://play.google.com/store/apps/details?id=com.cellnet.pickiddo"
                        >https://play.google.com/store/apps/details?id=com.cellnet.pickiddo</a
                      >
                      <br />
                      <br />
                      IOS user :
                      <br />
                      <a
                        href="https://apps.apple.com/my/app/pickiddo/id1366167288"
                        >https://apps.apple.com/my/app/pickiddo/id1366167288</a
                      >
                      <br />
                      <br />
                      <strong>2. Signup from the app</strong>
                      <br />
                      <br />

                      <a
                        href="https://play.google.com/store/apps/details?id=com.cellnet.pickiddo"
                        >https://play.google.com/store/apps/details?id=com.cellnet.pickiddo</a
                      >
                      Signup from the app
                      <br />
                      <br />
                      <strong
                        >3. Register/add your child from profile page in the
                        App</strong
                      >
                      <br />
                      <br />
                      <strong
                        >4. Inform admin on WhatsApp that you have done
                        register</strong
                      >
                      <br />
                      https://wa.me/60106597700
                    </h4>
                  </div>
                </CCard>

                <CCard color="light">
                  <div class="p-2">
                    <h4 class="text-left">
                      <strong
                        >What should I do after done with registration?</strong
                      >
                    </h4>
                  </div>
                </CCard>

                <CCard>
                  <div class="p-2">
                    <h4 class="text-left">
                      <strong
                        >1. What should I do after done with
                        registration?</strong
                      >
                      <br /><br />
                      Inform our admin on WhatsApp for them to check your
                      details on our website. https://wa.me/60106597700
                      <br /><br />
                      <strong
                        >2. To get tutor, you may use Find Tutor features on
                        Pickiddo application.
                      </strong>
                      <br /><br />

                      Open Pickiddo application > Find Tutor > Add New > Fill up
                      the details > View Tutor’s Resume > Appoint tutor For more
                      detailed steps, you can go to “Tutor” menu in this bot.
                    </h4>
                  </div>
                </CCard>

                <CCard color="light">
                  <div class="p-2">
                    <h4 class="text-left">
                      <strong
                        >WHEN CAN I START TO JOIN CLASS AFTER
                        REGISTRATION?</strong
                      >
                    </h4>
                  </div>
                </CCard>

                <CCard>
                  <div class="p-2">
                    <h4 class="text-left">
                      <strong>PREMIUM</strong> <br />
                      <br />
                      1. Admin will share your contact no the the teacher.  <br />
                      2.Teacher will contact you to discuss regarding when to
                      start and class schedule. <br />
                      <br />
                      <strong>GOLD</strong> <br />
                      <br />
                      1. We will find for you suitable partner that requested
                      for the same subject and grade.<br />
                      2. Whatsapp group will be created after we get the
                      suitable partner.<br />
                      3. Class schedule will be discuss among the parents in the
                      group and teacher.<br />
                      4. Teacher will share class link and materials in the
                      group once schedule is discussed.<br /><br />

                      <strong>TITAN</strong> <br />
                      <br />
                      1. Our admin will add you in the whatsapp group class
                      <br />
                      2. Class link will be share in the whatsapp group<br />
                    </h4>
                  </div>
                </CCard>
              </CCol>
            </CRow>
          </div>
        </div>
      </CRow>

      <CRow v-if="OnlineTutorPrice === true">
        <div class="card-custom-web">
          <div class="text-center mt-5">
            <CRow style="max-width: 100%">
              <CCol sm="4"
                ><h2>
                  <img
                    style="max-height: 40px"
                    class="mr-2"
                    src="../assets/img/icon/circle1.png"
                  /><strong>Package Provided</strong>
                </h2></CCol
              >
              <CCol sm="8">
                <CCard color="light">
                  <div class="p-2">
                    <h4 class="text-left">
                      <strong>How to Register ?</strong>
                    </h4>
                  </div>
                </CCard>

                <CCard>
                  <div class="p-2">
                    <h4 class="text-left">
                      <strong>1. Download our Pickiddo app:</strong>
                      <br />
                      <br />
                      Android user: : <br />
                      <a
                        href="https://play.google.com/store/apps/details?id=com.cellnet.pickiddo"
                        >https://play.google.com/store/apps/details?id=com.cellnet.pickiddo</a
                      >
                      <br />
                      <br />
                      IOS user :
                      <br />
                      <a
                        href="https://apps.apple.com/my/app/pickiddo/id1366167288"
                        >https://apps.apple.com/my/app/pickiddo/id1366167288</a
                      >
                      <br />
                      <br />
                      <strong>2. Signup from the app</strong>
                      <br />
                      <br />

                      <a
                        href="https://play.google.com/store/apps/details?id=com.cellnet.pickiddo"
                        >https://play.google.com/store/apps/details?id=com.cellnet.pickiddo</a
                      >
                      Signup from the app
                      <br />
                      <br />
                      <strong
                        >3. Register/add your child from profile page in the
                        App</strong
                      >
                      <br />
                      <br />
                      <strong
                        >4. Inform admin on WhatsApp that you have done
                        register</strong
                      >
                      <br />
                      https://wa.me/60106597700
                    </h4>
                  </div>
                </CCard>

                <CCard color="light">
                  <div class="p-2">
                    <h4 class="text-left">
                      <strong
                        >What should I do after done with registration?</strong
                      >
                    </h4>
                  </div>
                </CCard>

                <CCard>
                  <div class="p-2">
                    <h4 class="text-left">
                      <strong
                        >1. What should I do after done with
                        registration?</strong
                      >
                      <br /><br />
                      Inform our admin on WhatsApp for them to check your
                      details on our website. https://wa.me/60106597700
                      <br /><br />
                      <strong
                        >2. To get tutor, you may use Find Tutor features on
                        Pickiddo application.
                      </strong>
                      <br /><br />

                      Open Pickiddo application > Find Tutor > Add New > Fill up
                      the details > View Tutor’s Resume > Appoint tutor For more
                      detailed steps, you can go to “Tutor” menu in this bot.
                    </h4>
                  </div>
                </CCard>

                <CCard color="light">
                  <div class="p-2">
                    <h4 class="text-left">
                      <strong
                        >WHEN CAN I START TO JOIN CLASS AFTER
                        REGISTRATION?</strong
                      >
                    </h4>
                  </div>
                </CCard>

                <CCard>
                  <div class="p-2">
                    <h4 class="text-left">
                      <strong>PREMIUM</strong> <br />
                      <br />
                      1. Admin will share your contact no the the teacher.  <br />
                      2.Teacher will contact you to discuss regarding when to
                      start and class schedule. <br />
                      <br />
                      <strong>GOLD</strong> <br />
                      <br />
                      1. We will find for you suitable partner that requested
                      for the same subject and grade.<br />
                      2. Whatsapp group will be created after we get the
                      suitable partner.<br />
                      3. Class schedule will be discuss among the parents in the
                      group and teacher.<br />
                      4. Teacher will share class link and materials in the
                      group once schedule is discussed.<br /><br />

                      <strong>TITAN</strong> <br />
                      <br />
                      1. Our admin will add you in the whatsapp group class
                      <br />
                      2. Class link will be share in the whatsapp group<br />
                    </h4>
                  </div>
                </CCard>
              </CCol>
            </CRow>
          </div>
        </div>
      </CRow>

      <CRow v-if="TcPrice === true">
        <div class="card-custom-web">
          <div class="text-center mt-5">
            <CRow style="max-width: 100%">
              <CCol sm="4"
                ><h2>
                  <img
                    style="max-height: 40px"
                    class="mr-2"
                    src="../assets/img/icon/circle2.svg"
                  /><strong>Package Provided</strong>
                </h2></CCol
              >
              <CCol sm="8">
                <CCard color="light">
                  <div class="p-2">
                    <h4 class="text-left">
                      <strong>PRIMARY SCHOOL PACKAGE FEE </strong>
                    </h4>
                  </div>
                </CCard>

                <CCard>
                  <div class="p-2">
                    <h4 class="text-left">
                      <strong>1. Download our Pickiddo app:</strong>
                      <br />
                      <br />
                      Android user: : <br />
                      <a
                        href="https://play.google.com/store/apps/details?id=com.cellnet.pickiddo"
                        >https://play.google.com/store/apps/details?id=com.cellnet.pickiddo</a
                      >
                      <br />
                      <br />
                      IOS user :
                      <br />
                      <a
                        href="https://apps.apple.com/my/app/pickiddo/id1366167288"
                        >https://apps.apple.com/my/app/pickiddo/id1366167288</a
                      >
                      <br />
                      <br />
                      <strong>2. Signup from the app</strong>
                      <br />
                      <br />

                      <a
                        href="https://play.google.com/store/apps/details?id=com.cellnet.pickiddo"
                        >https://play.google.com/store/apps/details?id=com.cellnet.pickiddo</a
                      >
                      Signup from the app
                      <br />
                      <br />
                      <strong
                        >3. Register/add your child from profile page in the
                        App</strong
                      >
                      <br />
                      <br />
                      <strong
                        >4. Inform admin on WhatsApp that you have done
                        register</strong
                      >
                      <br />
                      https://wa.me/60106597700
                    </h4>
                  </div>
                </CCard>

                <CCard color="light">
                  <div class="p-2">
                    <h4 class="text-left">
                      <strong
                        >What should I do after done with registration?</strong
                      >
                    </h4>
                  </div>
                </CCard>

                <CCard>
                  <div class="p-2">
                    <h4 class="text-left">
                      <strong
                        >1. What should I do after done with
                        registration?</strong
                      >
                      <br /><br />
                      Inform our admin on WhatsApp for them to check your
                      details on our website. https://wa.me/60106597700
                      <br /><br />
                      <strong
                        >2. To get tutor, you may use Find Tutor features on
                        Pickiddo application.
                      </strong>
                      <br /><br />

                      Open Pickiddo application > Find Tutor > Add New > Fill up
                      the details > View Tutor’s Resume > Appoint tutor For more
                      detailed steps, you can go to “Tutor” menu in this bot.
                    </h4>
                  </div>
                </CCard>

                <CCard color="light">
                  <div class="p-2">
                    <h4 class="text-left">
                      <strong
                        >WHEN CAN I START TO JOIN CLASS AFTER
                        REGISTRATION?</strong
                      >
                    </h4>
                  </div>
                </CCard>

                <CCard>
                  <div class="p-2">
                    <h4 class="text-left">
                      <strong>PREMIUM</strong> <br />
                      <br />
                      1. Admin will share your contact no the the teacher.  <br />
                      2.Teacher will contact you to discuss regarding when to
                      start and class schedule. <br />
                      <br />
                      <strong>GOLD</strong> <br />
                      <br />
                      1. We will find for you suitable partner that requested
                      for the same subject and grade.<br />
                      2. Whatsapp group will be created after we get the
                      suitable partner.<br />
                      3. Class schedule will be discuss among the parents in the
                      group and teacher.<br />
                      4. Teacher will share class link and materials in the
                      group once schedule is discussed.<br /><br />

                      <strong>TITAN</strong> <br />
                      <br />
                      1. Our admin will add you in the whatsapp group class
                      <br />
                      2. Class link will be share in the whatsapp group<br />
                    </h4>
                  </div>
                </CCard>
              </CCol>
            </CRow>
          </div>
        </div>
      </CRow>

      <CRow v-if="ClassPrice === true">
        <div class="card-custom-web">
        
        </div>
      </CRow>
    </div>

    <Footerlayout></Footerlayout>
  </div>
</template>
  
  
  
  
  <script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import AnimatedNumber from "animated-number-vue";
import backgroundUrl from "../assets/img/bg3.png";

// import Translator from "vue-gtranslate";
// import "vue-gtranslate/translator.css";

Vue.use(require("vue-moment"));
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";

import Mainlayout from "../containers/AllHeaderLanding.vue";
import Footerlayout from "../containers/TheFooter.vue";

import VueAgile from "vue-agile";
Vue.use(VueAgile);

// in component

import AOS from "aos";
import "aos/dist/aos.css";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);

import VueCal from "vue-cal";
import "vue-cal/dist/vuecal.css";

import _ from "lodash";
import $ from "jquery";

import MenuIcon from "vue-material-design-icons/Menu.vue";
new Vue({
  el: "#navbar",

  data() {
    return {
      view: {
        topOfPage: true,
      },
    };
  },
  beforeMount() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      if (window.pageYOffset > 400) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
          el.setAttribute(
            "style",
            "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
          );
        }
      } else {
        if (!this.view.topOfPage) this.view.topOfPage = true;
        el.setAttribute(
          "style",
          "background: linear-gradient(286.01deg, rgb(91, 196, 255) 7.93%, rgb(0, 133, 255) 96.74%)"
        );
      }
    },
  },
});
export default {
  name: "Login",
  components: {
    Carousel3d,
    Slide,
    VueCal,
    MenuIcon,
    agile: VueAgile,
    Mainlayout,
    AnimatedNumber,
    backgroundUrl,
    Footerlayout,
  },
  data() {
    return {
      slides: 5,

      ParentPrice: true,
      isShowParent: true,

      PrimarySchool: true,
      SecondarySchool: false,
      isShowPrim: true,
      isShowSec: false,

      OnlineTutorPrice: false,
      isShowOnline: false,

      checked: true,
      checkAnnually: true,
      checkedMonthly: false,

      TcPrice: false,
      isShowTc: false,

      checkAnnuallyTc: true,
      checkedTc: true,

      ClassPrice: false,
      isShowClass: false,

      registerOrganization: false,

      showLess: false,
      showMoreAnn: true,

      showLessStarter: false,
      showMoreAnnStarter: true,

      showLessPro: false,
      showMoreAnnPro: true,

      showLessBusiness: false,
      showMoreAnnBusiness: true,

      showLessMhFree: false,
      showMoreMhFree: true,

      showLessMhStarter: false,
      showMoreMhStarter: true,

      showLessMhPro: false,
      showMoreMhPro: true,

      showLessMhBusiness: false,
      showMoreMhBusiness: true,

      show: false,
      isToggled: false,
    };
  },
  created() {
    AOS.init();
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  computed: {},

  methods: {
    toggle() {
      this.isToggled = !this.isToggled;
    },
    onScroll() {
      // Get the current scroll position
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
      if (currentScrollPosition < 0) {
        return;
      }
      // Here we determine whether we need to show or hide the navbar
      this.showNavbar = currentScrollPosition < this.lastScrollPosition;
      // Set the current scroll position as the last scroll position
      this.lastScrollPosition = currentScrollPosition;
    },
    handleScroll() {
      if (window.pageYOffset > 1000) {
        if (this.view.topOfPage) {
          this.view.topOfPage = false;
        } else {
          this.view.topOfPage = true;
        }
      }
    },
    ShowParent() {
      this.ParentPrice = true;
      this.isShowParent = true;
      this.isShowOnline = false;
      this.isShowTc = false;
      this.isShowClass = false;

      this.ClassPrice = false;
      this.TcPrice = false;
    },
    GoToPrimarySchool() {
      this.PrimarySchool = true;
      this.SecondarySchool = false;
      this.isShowPrim = true;
      this.isShowSec = false;
    },
    GoToSecondarySchool() {
      this.PrimarySchool = false;
      this.SecondarySchool = true;
      this.isShowSec = true;
      this.isShowPrim = false;
    },
    ShowOnlineTutor() {
      this.OnlineTutorPrice = true;
      this.ParentPrice = false;
      this.isShowParent = false;
      this.isShowOnline = true;
      this.isShowTc = false;
      this.isShowClass = false;
    },
    CheckedType() {
      if (this.checked) {
        this.checkAnnually = true;
        this.checkedMonthly = false;
      } else {
        this.checkAnnually = false;
        this.checkedMonthly = true;
      }
    },
    ShowTc() {
      this.TcPrice = true;

      this.isShowTc = true;
      this.isShowOnline = false;
      this.isShowParent = false;
      this.isShowClass = false;

      this.OnlineTutorPrice = false;
      this.ParentPrice = false;
      this.ClassPrice = false;
    },

    ShowClass() {
      this.ClassPrice = true;
      this.isShowClass = true;

      this.isShowOnline = false;
      this.isShowParent = false;
      this.isShowTc = false;

      this.OnlineTutorPrice = false;
      this.TcPrice = false;
      this.ParentPrice = false;
    },
    GoBack() {
      this.registerOrganization = false;
    },
    OpenOrganization() {
      this.registerOrganization = true;
    },
    ShowMoreAnFree() {
      this.showLess = true;
      this.showMoreAnn = false;
    },
    ShowLessAnFree() {
      this.showLess = false;
      this.showMoreAnn = true;
    },
    ShowMoreAnStarter() {
      this.showLessStarter = true;
      this.showMoreAnnStarter = false;
    },
    ShowLessAnStarter() {
      this.showLessStarter = false;
      this.showMoreAnnStarter = true;
    },
    ShowMoreAnPro() {
      this.showLessPro = true;
      this.showMoreAnnPro = false;
    },
    ShowLessAnPro() {
      this.showLessPro = false;
      this.showMoreAnnPro = true;
    },
    ShowMoreAnBusiness() {
      this.showLessBusiness = true;
      this.showMoreAnnBusiness = false;
    },
    ShowLessAnBusiness() {
      this.showLessBusiness = false;
      this.showMoreAnnBusiness = true;
    },
    ShowMoreMhFree() {
      this.showLessMhFree = true;
      this.showMoreMhFree = false;
    },
    ShowLessMhFree() {
      this.showLessMhFree = false;
      this.showMoreMhFree = true;
    },
    ShowMoreMhStarter() {
      this.showLessMhStarter = true;
      this.showMoreMhStarter = false;
    },
    ShowLessMhStarter() {
      this.showLessMhStarter = false;
      this.showMoreMhStarter = true;
    },
    ShowMoreMhPro() {
      this.showLessMhPro = true;
      this.showMoreMhPro = false;
    },
    ShowLessMhPro() {
      this.showLessMhPro = false;
      this.showMoreMhPro = true;
    },
    ShowMoreMhBusiness() {
      this.showLessMhBusiness = true;
      this.showMoreMhBusiness = false;
    },
    ShowLessMhBusiness() {
      this.showLessMhBusiness = false;
      this.showMoreMhBusiness = true;
    },
    BuyPackageAnnuallyFree(PackageId) {
      this.$router.push("EducationCenter?PackageId=" + PackageId);
    },
  },
};
</script>
      <style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");

.c-header {
  /* background: rgb(23, 77, 124);
    background: linear-gradient(92deg, #174d7c, #1b7682);
    border-bottom: 0.01px solid #1a6783;
    border-bottom: 1px solid #636f83; */

  background: transparent;
  border-bottom: 0;
  border-bottom: 0;
  /* color: #fff; */
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  font-family: "Montserrat", sans-serif;
}
body {
  font-family: "Montserrat", sans-serif;
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  font-family: "Montserrat", sans-serif;
}
label {
  font-family: "Montserrat", sans-serif;
}

body nav.onScroll {
  box-shadow: 0 0 10px #aaa;
  background-color: rgb(255, 255, 255);
  font-family: "Montserrat";
  font-style: normal;
}
body nav.onScroll ul li {
  color: #10b761;
}
body nav ul {
  margin-left: 3em;
  width: 25%;
  display: flex;
  justify-content: space-between;
}
body nav ul li {
  cursor: pointer;
  font-weight: 600;
  list-style-type: none;
  color: white;
}
body {
  top: 0 !important;
  font-family: "Montserrat", sans-serif;
}

input {
  border-bottom: 2px solid #fff;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: -webkit-fill-available;
  -webkit-text-fill-color: white !important;
}
input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.custom-user-input {
  /* Body/1/Semibold */

  display: flex;
  justify-content: center;
  flex-flow: row nowrap;
}
</style>